// extracted by mini-css-extract-plugin
export default {"description":"text-field_description"};